import { useCallback } from 'react';
import type { ProductListItem } from 'types/capi/shared';

import ProductCardImpressionEvent, {
  type ProductCardImpressionDisplayType
} from '~/events/ProductCardImpressionEvent';
import useImpression from '~/hooks/useImpression';
import useUser from '~/hooks/useUser';

type Options = {
  displayType?: ProductCardImpressionDisplayType;
  isBot: boolean;
  modulePosition?: number;
  moduleType?: string;
  position?: number;
  product: ProductListItem;
};

function useProductCardImpression({
  displayType,
  isBot,
  modulePosition,
  moduleType,
  position,
  product
}: Options) {
  const { guestId } = useUser();

  const track = useCallback(() => {
    new ProductCardImpressionEvent({
      displayType,
      guestId,
      isBot,
      modulePosition,
      moduleType,
      position,
      product
    }).track();
  }, [
    displayType,
    guestId,
    isBot,
    modulePosition,
    moduleType,
    position,
    product
  ]);

  return useImpression<HTMLDivElement>(track, { enabled: !isBot });
}

export default useProductCardImpression;
